export const BrowserWindowSymbol = Symbol('BrowserWindow')
export const ViewerModelSym = Symbol('ViewerModel')
export const LanguageSymbol = Symbol('Language')
export const ViewModeSym = Symbol('ViewMode')
export const Context = Symbol('Context')
export const ComponentLibrariesSymbol = Symbol('ComponentLibraries')
export const LoggerSymbol = Symbol('LOG')
export const MockModulesForTestsSymbol = Symbol('MockModulesForTestsSymbol')
export const WixCodeSdkParamsProviderSym = Symbol('WixCodeSdkParamsProviderSym')
export const PlatformEvnDataProviderSymbol = Symbol('PlatformEvnDataProviderSymbol')
export const WixCodeSdkHandlersProviderSym = Symbol('WixCodeSdkHandlersProviderSym')
export const PlatformSymbol = Symbol('PlatformSymbol')
export const PlatformStorageSymbol = Symbol('PlatformStorageSymbol')
export const PlatformWorkerPromiseSym = Symbol('PlatformWorkerPromiseSym')
export const WixCodeSdkProvidersRegistrarSym = Symbol('WixCodeSdkProvidersRegistrarSym')
export const RendererSymbol = Symbol('RendererSymbol')
export const DomReadySymbol = Symbol('DomReady')
